export default __webpack_public_path__ + "static/media/extension.e03f1131.svg";